import { getMasterData, getVehicleDocCountList, getVehicleDocDetialList } from '_services';
import { ActionPermissionModal, ButtonHeading, CommonDateRange, CrossButton, CustomPagination, CustomSelect, CustomTable, Customdropdown, Heading } from 'components';
import { UserContext } from 'context';
import { API, axiosInstance } from 'lib';
import { AddFundCanvas, EbillExtentionModal, EditTripOffCanvas, PaymentConfirmModal, RoutePanningModal } from 'modals';
import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { constant } from 'constants/constant';
import './testing.css'
import { LuCircleCheckBig, LuRefreshCw, LuUserRound, LuWallet } from 'react-icons/lu';
import { Usabilty } from 'pages/Usablity';
import { Wallet } from 'pages/Wallet';
import { DocumentOverview, ManageSubscription } from 'pages';
import { Button, Offcanvas } from 'react-bootstrap';
import { TbBuilding } from 'react-icons/tb';
import { FaRegClock, FaRegStar } from 'react-icons/fa6';
import { GoCheckCircleFill } from 'react-icons/go';
import Tab from 'components/common/Tab';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FiDownload } from 'react-icons/fi';
import { PiWarningCircle } from 'react-icons/pi';
import { MdOutlineCancel } from 'react-icons/md';
import { GrDocumentText } from 'react-icons/gr';
import { IoWarningOutline } from 'react-icons/io5';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import StorageService from 'utils/StorageServices/StorageServices';
import { utils } from 'helper';
import { getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import moment from 'moment';
import { RxCross2 } from 'react-icons/rx';
import BootstrapTable from 'components/BootstrapTable';





const Testing = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showRoutePlanning, setShowRoutePlanning] = useState(false);
    const [showEbillExtention, setShowEbillExtention] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const [activeTabBtn, setActiveTabBtn] = useState(2);
    const [searchParams, setSearchParams] = useSearchParams();
    const loadingBarRef = useRef(null);
    const [docDetailList, setDocDetailList] = useState([]);
    const [activeOwnership, setActiveOwnership] = useState("1");
    const activeData = docDetailList?.[activeOwnership];
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 20;
    const [documentTypeList, setDocumentTypeList] = useState([]);
    const [showAddFund, setShowAddFund] = useState(false);

    const [filter, setFilter] = useState({
        limit: 20,
        offset: 1,
        search: '',
        // status: 1
    });

    const [ownershipCount, setOwnershipCount] = useState({});
    const [activeOwnershipNw, setActiveOwnershipNw] = useState("1");





    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        const postData = {};

        try {
            let response = await getMasterData(postData);
            setData(response.data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }

    };


    const { cities } = useContext(UserContext);
    const [filteredCities, setFilteredCities] = useState([]);
    const [city, setCity] = useState([]);
    useEffect(() => {
        setFilteredCities(cities);
    }, [])



    const [selectedCity, setSelectedCity] = useState(null);


    const cities_new = [
        { label: 'New York', value: 'ny' },
        { label: 'Los Angeles', value: 'la' },
        { label: 'Chicago', value: 'ch' },
        { label: 'Houston', value: 'ho' },
        { label: 'Phoenix', value: 'ph' }
    ];

    const handleCitySelect = (city) => {
        setSelectedCity(city);
    };
    const handleCityChange = (city) => {
        setCity(city);
    };

    const SimpleColumns1 = ['Name', 'Age', 'Address',];

    const SimpleData1 = [
        {
            Name: 'John Doe',
            Age: 28,
            Address: `<div><p>123 Main St</p><p>Indore</p></div>`,
        },
        {
            Name: 'Jane Doe',
            Age: 34,
            Address: `<div><p>456 Maple Ave</p><p>jaipur</p></div>`,

        },
        {
            Name: 'Alice Johnson',
            Age: 23,
            Address: `<div><p>789 Oak St</p><p>delhi</p></div>`,

        },
    ];

    const filterableColumns1 = useMemo(() => ['Name', 'Age'], []); // Only 'Name' column is filterable for first table

    let routePlanModalProps = {
        isOpen: showRoutePlanning,
        closeModal: (e) => setShowRoutePlanning(false),
        onSubmit: (e) => setShowRoutePlanning(false),
        showModalFooter: false,
        modalMainClass: " _dashCommon_Modal _mapModal",
        modalTitle: "Route Planning",
        submitTitle: "Create Trip",
    };

    let ebillExpProps = {
        isOpen: showEbillExtention,
        closeModal: (e) => setShowEbillExtention(false),
        onSubmit: (e) => setShowEbillExtention(false),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
    };

    const getDocumentType = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                limit: 100,
                offset: 1,
                // search: '',
            }
            const res = await getVehicleDocTypeListData(object);
            if (res?.responseCode == 200) {
                let data = res?.data?.docTypes?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                        id: el?.id
                    }
                })
                setDocumentTypeList(data);
            }
        } catch (error) { }
    }

    const renderContent = () => {
        switch (activeTab) {
            case "wallet":
                return <Wallet />;
            case "usability":
                return <Usabilty />;
            case "manage":
                return <ManageSubscription />;
            case "billing":
                return <><div className='__payM_head'><h6>Billing History</h6></div></>;
            default:
                return null;
        }
    };

    // Change tab via tab ID → update URL with tab key
    const handleTabChange = (tabId) => {
        const selectedTab = constant.truckDocumentTabs.find(tab => tab.id === tabId);
        if (selectedTab) {
            setSearchParams({ t: selectedTab.value });
        }
    };

    const tabProps = {
        tabList: constant.accountTransactionTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab,
        // isActiveButton: true,
        // tabButtonName: 'Add Documents',
    };

    const tabBtnProps = {
        tabList: constant.summryDocsTabs,
        callBackTab: (e) => setActiveTabBtn(e),
        activeTab: activeTabBtn,
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const vehicleDocDetailList = async () => {
        try {
            loadingBarRef.current?.continuousStart();

            let object = {
                ...filter,
                doc_type_id: filter?.doc_type_id?.value,
                page: filter.offset,
                company_id: StorageService.getCompanyId(),
            };

            const res = await getVehicleDocDetialList(object);

            if (res?.responseCode == 200) {
                setDocDetailList(res?.data?.data);
                setOwnershipCount(res?.data?.ownershipCount);
                setTotalItems(res?.data?.total);
            }

        } finally {
            loadingBarRef.current?.complete();
        }
    };


    const getStatusUI = (status, expiry_date) => {
        switch (status) {
            case 1:
                return (
                    <div className='__vlExpireWrn_bx'>
                        <IoWarningOutline />
                        <span>Expired</span>
                    </div>
                );

            case 2:
                return (
                    <div className='__vlExpireSoon_bx'>
                        <IoIosCheckmarkCircleOutline />
                        <span>Expires soon</span>
                    </div>
                );

            case 3:
                return (
                    <div className='__vlVailid_bx'>
                        <IoIosCheckmarkCircleOutline />
                        <span>Valid</span>
                    </div>
                );

            case 4:
                return (
                    <div className='__vlNotAdd_bx'>
                        <IoWarningOutline />
                        <span>Not Added</span>
                    </div>
                );

            default:
                return "-";
        }
    };

    const [activeCustomer, setActiveCustomer] = useState("Customer1");


    // useEffect(() => {
    //     getDocumentType();
    //     vehicleDocDetailList();
    // }, [filter]);

    // const CustomerDetail = ({ title, showClose = false }) => {
    //     return (
    //         <section className="__cmnEntityDetail">
    //             <div className="__cmnfr">
    //                 <div className="__cmnHead_flexBx">
    //                     <div className="__cmnHeadTxt">{title}</div>

    //                     {showClose && (
    //                         <CrossButton
    //                             type="button"
    //                             className="_switchBtn __animEffect_btn"
    //                             style={{ marginLeft: "auto" }}
    //                         >
    //                             <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
    //                                 <path
    //                                     d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
    //                                     fill="black" />
    //                             </svg>
    //                         </CrossButton>
    //                     )}
    //                 </div>
    //             </div>

    //             <div className="__cmnSec addPr_flBx">
    //                 <Tab {...tabProps} />
    //             </div>

    //             <div className="__cmnThr">
    //                 {activeTab === 1 && <>Overview page</>}
    //                 {activeTab === 2 && <>Comment page</>}
    //                 {activeTab === 3 && <>Transaction page</>}
    //                 {activeTab === 4 && <>Mails page</>}
    //                 {activeTab === 5 && <>Statement page</>}
    //             </div>
    //         </section>
    //     );
    // };

    // const renderDetail = () => {
    //     switch (activeCustomer) {
    //         case "Customer1":
    //             return <CustomerDetail title="Customer 1" showClose />;

    //         case "Customer2":
    //             return <CustomerDetail title="Customer 2" showClose />;

    //         case "Customer3":
    //             return <CustomerDetail title="Customer 3" showClose />;

    //         default:
    //             return null;
    //     }
    // };


    // let confirmPayModalProps = {
    //     isOpen: showEbillExtention,
    //     closeModal: (e) => setShowEbillExtention(false),
    //     onSubmit: (e) => setShowEbillExtention(false),
    //     modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
    //     headerPart: true,
    //     floatCrossBtn: true,
    //     submitTitle: "Send Enquiry",
    // };

    const [selectedRange, setSelectedRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });



    const columns = [
        { header: "# Number", accessor: "number" },
        { header: "Voucher Date", accessor: "voucher_date" },
        { header: "Firm name", accessor: "firm_name" },
        { header: "Vendor", accessor: "vendor" },
        { header: "Total Amount", accessor: "total_amt" },
        { header: "Balance", accessor: "balance" },
        { header: "Under Approval", accessor: "under_approval" },
        { header: "Status", accessor: "status" },
        { header: "Tags", accessor: "tags" },
        { header: "Action", accessor: "action" },
    ];

    const list = [
        {
            id: 1,
            number: "BR2021-21",
            voucher_date: "24 Jun 2024",
            firm_name: "Oriental Retailers Pvt Ltd",
            vendor: "Parle Biscuit",
            total_amt: 63000,
            balance: 63000,
            under_approval: 0,
            status: "Pending",
            tags: ["MP20GA2109", "T2025-090"],
        },
        {
            id: 2,
            number: "BR2021-21",
            voucher_date: "24 Jun 2024",
            firm_name: "Oriental Retailers Pvt Ltd",
            vendor: "No Vendor",
            total_amt: 63000,
            balance: 63000,
            under_approval: 0,
            status: "Pending",
            tags: ["MP20GA2109", "T2025-090"],
        },
    ];

    // const RowListData = (data = []) => {
    //     return data.map((item) => ({
    //         number: <span>{item.number}</span>,

    //         voucher_date: <span>{item.voucher_date}</span>,

    //         firm_name: (
    //             <>
    //                 <div style={{ fontWeight: 500 }}>{item.firm_name}</div>
    //             </>
    //         ),

    //         vendor: (
    //             <>
    //                 <div>{item.vendor}</div>
    //                 <small style={{ color: "#8a8a8a" }}>Vendor Type</small>
    //             </>
    //         ),

    //         total_amt: <span>₹{item.total_amt.toLocaleString()}</span>,

    //         balance: <span>₹{item.balance.toLocaleString()}</span>,

    //         under_approval: <span>₹ {item.under_approval.toFixed(2)}</span>,

    //         status: (
    //             <span
    //                 style={{
    //                     background: "#FF902B",
    //                     color: "#fff",
    //                     padding: "3px 10px",
    //                     borderRadius: "12px",
    //                     fontSize: "11px",
    //                 }}
    //             >
    //                 {item.status}
    //             </span>
    //         ),

    //         tags: (
    //             <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
    //                 {item.tags.map((tag, i) => (
    //                     <span
    //                         key={i}
    //                         style={{
    //                             border: "1px solid #ddd",
    //                             padding: "2px 6px",
    //                             borderRadius: "4px",
    //                             fontSize: "11px",
    //                         }}
    //                     >
    //                         {tag}
    //                     </span>
    //                 ))}
    //             </div>
    //         ),

    //         action: (
    //             <span style={{ cursor: "pointer", fontSize: "18px" }}>⋮</span>
    //         ),
    //     }));
    // };

    const RowListData = (data = []) => {
        const navigate = useNavigate();

        return data.map((item) => ({
            _rowProps: {
                onClick: () => navigate(`/voucher-details/${item.id}`),
                style: { cursor: "pointer" },
            },

            number: <span>{item.number}</span>,

            voucher_date: <span>{item.voucher_date}</span>,

            firm_name: (
                <span
                    style={{ cursor: "pointer" }}
                    // onClick={() => navigate(`/voucher-details/${item.id}`)}
                    onClick={() => navigate(`/accounting/transactionExpDetails`)}
                >
                    {item.firm_name}
                </span>
            ),

            vendor: (
                <>
                    <div>{item.vendor}</div>
                    <small className="text-muted">Vendor Type</small>
                </>
            ),

            total_amt: <span>₹{item.total_amt.toLocaleString()}</span>,

            balance: <span>₹{item.balance.toLocaleString()}</span>,

            under_approval: <span>₹ {item.under_approval.toFixed(2)}</span>,

            status: (
                <span className='trs-status'>
                    {item.status}
                </span>
                //   <span className="badge bg-warning text-white">
                //     {item.status}
                //   </span>
            ),

            tags: (
                <div className="d-flex gap-1 flex-wrap">
                    {item.tags.map((tag, i) => (
                        <span key={i} className="tag-badge-bx">
                            {tag}
                        </span>
                    ))}
                </div>
            ),

            action: <span>⋮</span>,
        }));
    };


    return (
        <>


            {/* Accounting Submenu Transactions Design 19-Feb-26 */}
            <div className='transation-all-mainBx'>
                <ButtonHeading title="Transactions" buttonTitle="Add Transactions" onClick={() => console.log("Add Transactions clicked")} className="transactions-head-button" />

                <div className="addPr_flBx __uiTx_new">
                    <Tab {...tabProps} />

                    <div className='transation-subContents'>
                        {activeTab === 1 &&
                            <div className='transaction-exp-bxs'>
                                <div className='trs-exp-head'>
                                    <div className='trs-datePicker'>
                                        <CommonDateRange
                                        // key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                        // initialStartDate={selectedRange.startDate}
                                        // initialEndDate={selectedRange.endDate}
                                        // onApply={handleApply}
                                        />
                                    </div>

                                    <div className="_inpW_search _lrl_inpSrch">
                                        <svg
                                            className="srcIcon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                        >
                                            <path
                                                opacity="0.2"
                                                d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                                                fill="black"
                                            />
                                        </svg>
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="simpleFilter_input"
                                            name="search"
                                        // value={getSearchValue?.search}
                                        // onChange={(e) =>
                                        //     searchFilterOnChange("search", e.target.value)
                                        // }
                                        />
                                        {/* {getSearchValue?.search ? (
                                        <span
                                            className="clear-icon"
                                            onClick={(e) => searchFilterOnChange("")}
                                        >
                                            <RxCross2 size={20} color="black" />
                                        </span>
                                    ) : (
                                        <></>
                                    )} */}
                                    </div>
                                </div>

                                <div className='trs-exp-table'>
                                    <BootstrapTable
                                        tableClass="trs-exp-table-inner"
                                        columns={columns}
                                        data={RowListData(list)}
                                    />

                                    <div className='paginationFt_avt'>
                                        <CustomPagination
                                            totalItems={1}
                                            itemsPerPage={1}
                                            currentPage={1}
                                        // onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        {activeTab === 2 && <>Servicing</>}
                        {activeTab === 3 && <>EMI</>}
                        {activeTab === 4 && <>Documents</>}
                        {activeTab === 5 && <>Salary</>}
                        {activeTab === 6 && <>Purchase</>}
                        {activeTab === 7 && <>Pay Claim</>}
                        {activeTab === 8 && <>Charge Claim</>}
                    </div>

                </div>
            </div>
            {/* Accounting Submenu Transactions Design 19-Feb-26 */}





            {/* Pay Now module Design 23-Jan-2026 */}
            {/* <ButtonHeading title="Pay Now" />

            <div className='__payNw_mainBx'>
                <div className='__pyAll_filts'>

                    <div className='__pyFirst_flts'>
                        <div className='__pyBal_row'>
                            <div className='__payWal_icon'><LuWallet /></div>

                            <div className='__payWal_row'>
                                <div className='__payAll_bal_bx'>
                                    <div className='__pyAc_head'>Account Balance</div>
                                    <p className='__pyAcc_bal'>₹ 170</p>
                                </div>

                                <div className='__payAll_bal_bx'>
                                    <div className='__pyAc_head'>Under Process</div>
                                    <p className='__pyUnPro_bal'>₹ 170</p>
                                </div>

                                <div className='__payAll_bal_bx'>
                                    <div className='__pyAc_head'>Failed</div>
                                    <p className='__pyFail_bal'>₹ 170</p>
                                </div>
                            </div>

                            <div className="__pyBal_actions">
                                <button className="anime-btn __btn_addFunds" onClick={() => setShowAddFund(true)}>Add Funds</button>
                                <button className="anime-btn __btn_statement">Statement</button>
                            </div>
                        </div>
                    </div>

                    <div className='__seletionFlx_bx'>
                        <div className='__selcField_bx'>
                            <CustomSelect
                                placeholder={`Category`}
                                label={`Category`}
                                options={cities_new}
                            />
                        </div>

                        <div className='__selcField_bx'>
                            <CommonDateRange
                                initialStartDate={moment()}
                                initialEndDate={moment()}
                            />
                        </div>

                        <div className='__selcField_bx'>
                            <CustomSelect
                                placeholder={`Status`}
                                label={`Status`}
                                options={cities_new}
                            />
                        </div>

                        <div className='__selcField_bx'>
                            <div className='_inpW_search _lrl_inpSrch '>
                                <svg
                                    className="srcIcon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        opacity="0.2"
                                        d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                                        fill="black"
                                    ></path>
                                </svg>
                                <input
                                    type="text"
                                    className='simpleFilter_input'
                                    placeholder='Search'
                                />
                            </div>
                        </div>

                        <button className='anime-btn __btn_resetFilter'>Reset Filter</button>
                    </div>

                </div>

                <div className='pas_tableMain'>
                    <table className="pas_table">
                        <thead>
                            <tr>
                                <th>Date & Time</th>
                                <th>Txn ID</th>
                                <th>Reference</th>
                                <th>Category</th>
                                <th>Mode</th>
                                <th>To Account</th>
                                <th>Status</th>
                                <th>Cr./Dr.</th>
                                <th>Amount</th>
                                <th>Balance</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>
                                    <p>14 Jan 26</p>
                                    <span>03:19 PM</span>
                                </td>

                                <td><span>138528128</span></td>

                                <td>
                                    <span>Wallet Recharge</span>
                                </td>

                                <td>
                                    <p>Advance Freight</p>
                                    <div style={{ fontSize: '11.2px' }}>
                                        <p className="pas_decs">Indore- Bhopal</p>
                                        <p className="pas_decs">MP20GA2109</p>
                                    </div>
                                </td>

                                <td>
                                    <p>IMPS</p>
                                </td>

                                <td>
                                    <p className="pas_decs">Guddu Transport & Logistics</p>

                                    <div style={{ fontSize: '11.2px' }}>
                                        <p className="pas_decs">A/C Number: 21312312312313</p>
                                        <p className="pas_decs">IFSC: 3247283472</p>
                                        <p className="pas_decs">Bank: HDFC</p>
                                        <p className="pas_decs">Holder : Gudu Singh Transport</p>
                                    </div>
                                </td>

                                <td>
                                    <div className="__pas_success_bx">Success</div>
                                    <p style={{ fontSize: '11.2px' }}>14 Jan 26 | 03:19 PM</p>
                                </td>

                                <td>
                                    <div className="__pas_cr_bx">CR</div>
                                </td>

                                <td>
                                    <p className="__pas_cr_txt">₹ 170</p>
                                </td>

                                <td>
                                    <p>₹ 3,001</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>14 Jan 26</p>
                                    <span>03:19 PM</span>
                                </td>

                                <td><span>138528128</span></td>

                                <td>
                                    <span>Wallet Recharge</span>
                                </td>

                                <td>
                                    <p>Advance Freight</p>

                                    <div style={{ fontSize: '11.2px' }}>
                                        <p className="pas_decs">Indore- Bhopal</p>
                                        <p className="pas_decs">MP20GA2109</p>
                                    </div>
                                </td>

                                <td>
                                    <p>IMPS</p>
                                </td>

                                <td>
                                    <p className="pas_decs">Guddu Transport & Logistics</p>

                                    <div style={{ fontSize: '11.2px' }}>
                                        <p className="pas_decs">A/C Number: 21312312312313</p>
                                        <p className="pas_decs">IFSC: 3247283472</p>
                                        <p className="pas_decs">Bank: HDFC</p>
                                        <p className="pas_decs">Holder : Gudu Singh Transport</p>
                                    </div>
                                </td>

                                <td>
                                    <div className="__pas_success_bx">Success</div>
                                    <p style={{ fontSize: '11.2px' }}>14 Jan 26 | 03:19 PM</p>
                                </td>

                                <td>
                                    <div className="__pas_cr_bx">CR</div>
                                </td>

                                <td>
                                    <p className="__pas_cr_txt">₹ 170</p>
                                </td>

                                <td>
                                    <p>₹ 3,001</p>
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>

                <div className='paginationFt_avt '>
                    <CustomPagination
                    />
                </div>
            </div> */}
            {/* Pay Now module Design 23-Jan-2026 */}





            {/* Confirm Payment Module */}
            {/* <div className='p-3'>
                <button className='anime-btn _addComm_btn' onClick={() => setShowPayConfirmCanvas(true)}>Confirm Payment</button>
            </div> */}

            {/* <div
                className={`offcanvas offcanvas-end common_offCanvas payConfirmCanvas ${showAddFund ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showAddFund ? "visible" : "hidden" }}
            >
                {showAddFund && (
                    <>
                        <AddFundCanvas
                            isOpen={showAddFund}
                            closeModal={() => setShowAddFund(false)}
                        />
                    </>
                )}
            </div> */}

            {/* <div className={showAddFund ? "offBack_drop" : ""}></div> */}




            {/* Confirm Payment Module */}




            {/* List And Detail Page */}
            {/* <div className='__cmnListDetail'> */}
            {/* List box */}
            {/* <div className='__cmnListBx_ns'>
                    <div className='__cmnListBx_ns_head'>All Customers</div>

                    <div className="__cmnListBx_ns_content">
                        {["Customer1", "Customer2", "Customer3"].map((item) => (
                            <div
                                key={item}
                                className={`__cmnInLine ${activeCustomer === item ? "active" : ""}`}
                                onClick={() => setActiveCustomer(item)}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div> */}

            {/* Detail box */}
            {/* <div className="__cmnDetailBx">
                    {renderDetail()}
                </div>
            </div> */}
            {/* List And Detail Page */}


        </>
    );
};

export default Testing;
